<div [class]="classes" id="app-store-logos">
  <a href="{{ios_app_link}}"><img src="assets/img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" alt="Download on the App Store"></a>
  <a href="{{android_app_link}}"><img src="assets/img/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play"></a>
</div>